export default "__VITE_ASSET__SD9pBL0$__"